import { groupBy } from 'assets/utilities';
import constants from 'assets/utilities/constants';

export const groupItems = (items = []) => groupBy(
  items.map((item, index) => ({
    ...item,
    // NOTE: trial is shown as shipping today, with future subscription shown
    frequency: item.properties && item.product_type !== constants.cart.trialType
      ? item.properties.shipping_interval_frequency || 0
      : 0,
    line: index + 1,
  })),
  'frequency',
);

export const getCartItemGroups = cartItems => Object.values(groupItems(cartItems))
  .sort((groupA, groupB) => groupA.frequency - groupB.frequency);
